// photo received status of an inv batch item
export const PHOTO_RECEIVED_STATUS = {
  COMPLETED : 'completed',
  PENDING   : 'pending'
}

// put_away_status of an inv batch item
export const PUT_AWAY_STATUS = {
  COMPLETED : 'completed',
  PENDING   : 'pending',
  PARTIAL   : 'partial'
}

// static code, no relation with backend
export const TABLE_STATUS = {
  PENDING_RECEIVED     : 'pending_received',
  RECEIVED             : 'received',
  PENDING_PHOTOGRAPHY  : 'pending_photography',
  COMPLETE_PHOTOGRAPHY : 'complete_photography',
  REJECTED             : 'rejected'
}
